module.exports = {
  TRAIN_STATION: 'train-station',
  AIRPORT: 'airport',
  SEAPORT: 'seaport',

  // TODO: Remove it?
  CITY: 'city',
};
